import { render, staticRenderFns } from "./ConfirmMove.vue?vue&type=template&id=d58e78ca&scoped=true&"
import script from "./ConfirmMove.vue?vue&type=script&lang=ts&"
export * from "./ConfirmMove.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58e78ca",
  null
  
)

export default component.exports